module.exports = __webpack_public_path__ + "img/3DScan_5.614be890.png";